import React from "react";
import OverviewBlockViews from "./overviewBlockViews";
import OverviewBlockLikes from "./overviewBlockLikes";

const OverviewBlock = (props) => {
  const { dataBlock, darkMode, renderIcon, renderValue, renderTrend } = props;

  const renderBlock = (title) => {
    if (title === "instagram" || title === "youtube") {
      return (
        <div className="overviewblock">
          <OverviewBlockLikes
            dataBlock={dataBlock}
            darkMode={darkMode}
            renderIcon={renderIcon}
            renderValue={renderValue}
            renderTrend={renderTrend}
          />

          <OverviewBlockViews
            dataBlock={dataBlock}
            darkMode={darkMode}
            renderIcon={renderIcon}
            renderValue={renderValue}
            renderTrend={renderTrend}
          />
        </div>
      );
    } else {
      return (
        <div className="overviewblock">
          <OverviewBlockViews
            dataBlock={dataBlock}
            darkMode={darkMode}
            renderIcon={renderIcon}
            renderValue={renderValue}
            renderTrend={renderTrend}
          />

          <OverviewBlockLikes
            dataBlock={dataBlock}
            darkMode={darkMode}
            renderIcon={renderIcon}
            renderValue={renderValue}
            renderTrend={renderTrend}
          />
        </div>
      );
    }
  };

  return renderBlock(dataBlock.title);
};

export default OverviewBlock;
